import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie';
import { Router } from '@angular/router';
import { Http, Response, Headers } from '@angular/http';
import 'rxjs/Rx';
import { Observable } from 'rxjs/Rx';
import { ConfigService } from '../../config/config.service';
import {Subscription} from "rxjs/Subscription";


@Injectable()
export class SessionService {
    sub: Subscription;

    constructor(private http: Http, private _cookieService: CookieService, private router: Router, private config: ConfigService) { }

    logout() {
        localStorage.removeItem('cart_for_axxess_shopping');
        this.destroySessionCookie(true);
        //this.setLogged(false);
    }

    addUserType(type) {
        localStorage.removeItem('admin_type');
        localStorage.setItem('admin_type', type);
    }

    getUserType() {
         if(localStorage.getItem('admin_type') === null) {
             return 'USER';
         } else {
             return localStorage.getItem('admin_type') ;
         }

    }

    setMerchantIdCookie(id, domain) {
        let cookieExpiry: number = Date.now() + 29 * 60 * 1000;
        return this._cookieService.put('merchantId', id, { expires: new Date(cookieExpiry), path: '/', domain: domain });
    }

    setMerchantSessionCookie(token, domain, tokenExpireSeconds) {
        let cookieExpiry: number = Date.now() + (tokenExpireSeconds * 1000);
        return this._cookieService.put('user_token_merchant', token, { expires: new Date(cookieExpiry), path: '/', domain: domain });
    }

    setMerchantRefreshToken(token, domain) {
        let cookieExpiry: number = Date.now() + 30 * 24 * 60 * 60 * 1000;
        return this._cookieService.put('refresh_token_merchant', token, { expires: new Date(cookieExpiry), path: '/', domain: domain });
    }

    setSessionCookie(token, tokenExpireSeconds) {
        if (typeof this.sub == 'undefined' ) {
            this.subscribeForForceRefresh((tokenExpireSeconds - tokenExpireSeconds/10) * 1000);
        }
        let cookieExpiry: number = Date.now() + (tokenExpireSeconds * 1000);
        return this._cookieService.put('user_token_admin', token, { expires: new Date(cookieExpiry) });
    }

    subscribeForForceRefresh(interval) {
        this.sub = Observable.interval(interval)
            .subscribe(() => {
                this.forceRefreshToken();
            });
    }

    forceRefreshToken() {
        this.refreshToken().subscribe(
            data => {
                this.destroySessionCookie(false);
                this.rememberUser(data.accessToken);
                this.rememberRefreshToken(data.refreshToken);
                this.setSessionCookie(data.accessToken, data.expiresInSeconds);
                this.setRefreshToken(data.refreshToken);
            });
    }

    unsubscribeFromForceRefresh() {
        if (typeof this.sub != 'undefined') {
            this.sub.unsubscribe();
            this.sub = undefined;
        }
    }

    setRefreshToken(token) {
        let cookieExpiry: number = Date.now() + 30 * 24 * 60 * 60 * 1000;
        return this._cookieService.put('refresh_token_admin', token, { expires: new Date(cookieExpiry) });
    }

    checkSessionCookie() {
        return this._cookieService.get('user_token_admin');
    }

    checkRefreshToken() {
        return this._cookieService.get('refresh_token_admin');
    }

    checkStorageSession() {
        return localStorage.getItem('user_token_admin');
    }

    checkStorageRefreshToken() {
        return localStorage.getItem('refresh_token_admin');
    }

    isAuthenticated(): boolean {
        if (!this.checkSessionCookie() ) {
            return false;
        } else {
            return true;
        }
    }

    rememberUser(token) {
        localStorage.setItem('user_token_admin', token);
    }

    rememberRefreshToken(token) {
        localStorage.setItem('refresh_token_admin', token);
    }

    destroySessionCookie(willDestroyAdminType) {
        localStorage.removeItem('user_token_admin');
        this._cookieService.remove('user_token_admin');
        localStorage.removeItem('refresh_token_admin');
        this._cookieService.remove('refresh_token_admin');
        if(willDestroyAdminType) {
            localStorage.removeItem('admin_type');
        }
    }

    getToken() {
        let user_token;
        if (this.checkSessionCookie() !== undefined) {
            user_token = this.checkSessionCookie();
        } else if (this.checkStorageSession() != null) {
            user_token = this.checkStorageSession();
        }
        return user_token;
    }

    getRefreshToken() {
        let refresh_token;
        if (this.checkRefreshToken() !== undefined) {
            refresh_token = this.checkRefreshToken();
        } else if (this.checkStorageRefreshToken() != null) {
            refresh_token = this.checkStorageRefreshToken();
        }
        return refresh_token;
    }

    refreshToken() {
        let body = {"refreshToken" : this.getRefreshToken()};
        let headers = new Headers();

        return this.http.post(this.config.refreshToken, body, {
            headers: headers
        })
            .map((data: Response) => data.json())
            .catch(this.handleError.bind(this));
    }

    haveToRefresh() {
        if(this.checkSessionCookie()) {
            return false;
        }
        if(this.checkStorageSession()) {
            return true;
        }
        return false;/// here we dont have cookie and storage
    }

    /*refreshTokensDurationOnEveryCall(){
        if(undefined !== this.checkSessionCookie() && null !== this.checkSessionCookie()){
            this.setSessionCookie(this.checkSessionCookie());
        };
        if(undefined !== this.checkRefreshToken() && null !== this.checkRefreshToken()){
            this.setRefreshToken(this.checkRefreshToken());
        };
    }*/

    private handleError(error: any) {
        if( error && (( 403 === error.status ) || ( 401 === error.status ))) {
            if(this.router &&  ('function' === typeof this.router.navigate)) {
                this.unsubscribeFromForceRefresh();
                this.router.navigate(['/']);
            }
            return Observable.throw(error.json());
            //return;
        } else {
            return Observable.throw(error.json());
        }
    }

    clearAllSorting(){
        localStorage.removeItem('membersGridSorting');
        localStorage.removeItem('offersGridSorting');
        localStorage.removeItem('merchantssGridSorting');
        localStorage.removeItem('ordersGridSorting');
        localStorage.removeItem('productcardsGridSorting');
        localStorage.removeItem('terminalsGridSorting');
        localStorage.removeItem('redemptionsGridSorting');
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/session.service.ts